<template>
  <div class="flex flex-col gap-1">
    <div v-if="ongoingObjectives && ongoingObjectives.length" class="flex flex-col">
      <h4 class="text-title-small text-on-surface-variant mb-1">
        {{ $t('objective.ongoing') }}
      </h4>
      <ul class="flex flex-col gap-0.5">
        <li
          v-for="objective in ongoingObjectives"
          :key="objective.id"
          class="first:[&>div]:rounded-t-large last:[&>div]:rounded-b-large [&>div]:rounded-small"
        >
          <ObjectiveItemPreview
            :objective="objective"
            :is-editable="true"
            :dialog-phase="dialogPhase"
          />
        </li>
      </ul>
    </div>
    <div v-if="createdObjectives && createdObjectives.length" class="flex flex-col">
      <h4 class="text-title-small text-on-surface-variant mb-1">
        {{ $t('objective.created') }}
      </h4>
      <ul class="flex flex-col gap-0.5">
        <li
          v-for="objective in createdObjectives"
          :key="objective.id"
          class="first:[&>div]:rounded-t-large last:[&>div]:rounded-b-large [&>div]:rounded-small"
        >
          <ImpulseItem
            v-if="objective.isImpulse"
            :objective="objective"
            :is-read-only="areImpulsesReadOnly"
            :dialog-phase="dialogPhase"
          />
          <ObjectiveItemPreview
            v-else
            :objective="objective"
            :is-editable="!!canCreateImpulse"
            :dialog-phase="dialogPhase"
          />
        </li>
      </ul>
    </div>
    <div v-if="canCreateImpulse">
      <BaseIconButton
        v-if="!showForm && !isExpanded"
        icon="target"
        size="M"
        color="filled"
        @click="$emit('create:impulse')"
        v-tooltip="$t('objective.impulse.action')"
      />
      <BaseTextButton
        v-if="!showForm && isExpanded"
        icon="track_changes"
        :color="createdObjectives.length > 0 ? 'outlined' : 'filled'"
        @click="$emit('create:impulse')"
        class="w-full"
        >{{ $t('objective.impulse.action') }}</BaseTextButton
      >
    </div>

    <div v-if="showForm" class="bg-surface-container-highest rounded-large w-full p-4">
      <BaseInputField
        v-model="creatableImpulse.title"
        :required="true"
        autofocus
        hide-decorators
        type="text"
        class="bg-surface-container-highest w-full"
        :label="$t('objective.impulse.title')"
      />
      <div class="mt-2 flex w-full flex-row justify-end gap-1">
        <BaseTextButton @click="$emit('cancel:create')" size="XS">{{
          $t('common.cancel')
        }}</BaseTextButton>
        <BaseTextButton @click="$emit('save:impulse')" size="XS" color="filled">{{
          $t('common.save')
        }}</BaseTextButton>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import type { CreateableImpulse, Objective } from '@/core/composables/use-objectives'
  import BaseTextButton from '../../../core/components/base/button/text-button/BaseTextButton.vue'
  import BaseIconButton from '../base/button/icon-button/BaseIconButton.vue'
  import BaseInputField from '../base/form-fields/BaseInputField.vue'
  import ImpulseItem from './ImpulseItem.vue'
  import ObjectiveItemPreview from './ObjectiveItemPreview.vue'
  import type { DialogPhase } from '@/core/models/dialog/dialog.ts'

  interface Props {
    createdObjectives: ReadonlyArray<Objective>
    ongoingObjectives: ReadonlyArray<Objective>
    showForm: boolean
    creatableImpulse: Partial<CreateableImpulse>
    dialogId: string
    areImpulsesReadOnly?: boolean
    isExpanded?: boolean
    canCreateImpulse?: boolean
    dialogPhase: DialogPhase
  }

  defineProps<Props>()

  defineEmits<{
    (e: 'create:impulse'): void
    (e: 'cancel:create'): void
    (e: 'save:impulse'): void
    (e: 'update:creatableObjectiveTitle', title: string): void
  }>()
</script>
